import { useSelector } from 'react-redux';
import { AppState } from '../../../types/state/AppState';
import { useMemo } from 'react';
import { apiUtils } from '../../../utils';

export const useRegByUsers = () => {
    const users = useSelector((state: AppState) => state.companies.users);
    return useMemo(() => apiUtils.normalize(users, (c) => c.createdById, (c) => c.createdBy),[users]);
}
